export const defaultColumns = [
  { label: 'Status', value: 'status', className: 'w-20' },
  { label: 'Tipo', value: 'kind', className: 'w-20' },
  { label: 'Nome', value: 'fantasy_name' },
  { label: 'Crédito', value: 'granted_credit', className: 'w-20' },
  { label: 'Consumo', value: 'consumed_credit', className: 'w-20' },
  { label: 'Consumo (não pago)', value: 'unpaid_consumed_credit', className: 'w-20' },
  { label: 'Restante', value: 'remaining_credit', className: 'w-20' },
  { label: 'Equip.', value: 'equipments_count', className: 'w-20' },
  { label: 'Filiais', value: 'branches_count', className: 'w-20' },
  { label: 'Usuários', value: 'users_count', className: 'w-20' },
  { label: 'Cartões', value: 'enabled_cards_count', className: 'w-20' },
  { label: 'Ações', value: 'actions', className: 'w-9' },
]
